<template>
    <div>
        <div style="width: 100%; height: 100%; justify-content: flex-start; align-items: flex-start; gap: 32px; display: inline-flex; flex-wrap: wrap;">
            <div style="flex: 1 1 0; align-self: stretch; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex">
                <div style="align-self: stretch; padding-bottom: 16px; justify-content: center; align-items: flex-start; display: inline-flex; border-radius: 12px; border: 1px #E5E5E5 solid; ">
                    <div style="flex: 1 1 0; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 32px; display: inline-flex; margin-left: 16px; margin-top: 16px; margin-bottom: 16px">
                        <div style="align-self: stretch; height: 44px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                            <div style="color: #344054; font-size: 16px; font-weight: 600; line-height: 20px; word-wrap: break-word; display: inline-block">{{this.percent_parcels_used}}% of Parcels Used</div>
                            <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 12px; display: inline-flex">
                                <div style="width: 612px; height: 8px; position: relative; border-radius: 8px">
                                    <div style="width: 612px; height: 16px; left: 0px; top: 0px; position: absolute; background: #EAECF0; border-radius: 4px"></div>
                                    <div style="height: 16px; left: 0px; top: 0px; position: absolute; background: #4A7EE8; border-radius: 4px" :style="this.sizingParcels"></div>
                                </div>
                                <div style="color: #344054; font-size: 14px; font-weight: 500; line-height: 20px; word-wrap: break-word">
                                    {{this.parcels_used}} / {{this.parcels_bought}}</div>
                            </div>
                        </div>
                        <div style="align-self: stretch; height: 44px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                            <div style="color: #344054; font-size: 16px; font-weight: 600; line-height: 20px; word-wrap: break-word; display: inline-block">{{this.percent_tiles_used}}% of Tiles Used</div>
                            <div style="align-self: stretch; justify-content: flex-start; align-items: center; gap: 12px; display: inline-flex">
                                <div style="width: 607px; height: 8px; position: relative; border-radius: 8px">
                                    <div style="width: 607px; height: 16px; left: 0px; top: 0px; position: absolute; background: #EAECF0; border-radius: 4px"></div>
                                    <div style="height: 16px; left: 0px; top: 0px; position: absolute; background: #475467; border-radius: 4px" :style="this.sizingTiles"></div>
                                </div>
                                <div style="color: #344054; font-size: 14px; font-weight: 500; line-height: 20px; word-wrap: break-word">
                                    {{this.tiles_used}} / {{this.tiles_bought}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="align-self: stretch; height: 330px; padding: 24px; border-radius: 12px; border: 1px #E5E5E5 solid; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 24px; display: flex">
                    <div style="align-self: stretch; justify-content: flex-start; align-items: flex-end; gap: 16px; display: inline-flex">
                        <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                            <div style="color: #2D5762; font-size: 16px; font-family: Inter; font-weight: 600; line-height: 28px; word-wrap: break-word">Total Usage</div>
                            <div style="justify-content: flex-start; align-items: flex-end; gap: 16px; display: inline-flex">
                                <div style="color: #101828; font-size: 24px; font-family: Inter; font-weight: 600; line-height: 38px; word-wrap: break-word">
                                    {{ this.totalUsage }}</div>

                            </div>
                        </div>
                        <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                            <div v-if="selected==3" style="color: #2D5762; font-size: 16px; font-family: Inter; font-weight: 600; line-height: 28px; word-wrap: break-word">Monthly Avg</div>

                            <div v-else style="color: #2D5762; font-size: 16px; font-family: Inter; font-weight: 600; line-height: 28px; word-wrap: break-word">Daily Avg</div>
                            <div style="justify-content: flex-start; align-items: flex-end; gap: 16px; display: inline-flex">
                                <div style="color: #101828; font-size: 24px; font-family: Inter; font-weight: 600; line-height: 38px; word-wrap: break-word">
                                    {{ this.dailyAvg }}</div>

                            </div>
                        </div>
                        <div style="flex: 1 1 0; align-self: stretch; justify-content: flex-end; align-items: flex-start; gap: 16px; display: flex">

                            <div style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
                                <select style="width: 146px" v-model="selected" v-on:change="updateGraph()">
                                    <option :value=null disabled state-active="">Select a view option
                                    </option>
                                    <option :value="item.value" v-for="(item, index) in options">{{ item.text }}
                                    </option>
                                </select>
                                <div v-show="selected==0">
                                    <el-date-picker
                                        style="width:146px !important;min-width: 146px !important;"
                                        size="mini"
                                        v-model="dayValue"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="Pick a day"
                                        @change="updateGraphDay($event)">
                                    </el-date-picker>
                                </div>
                                <div v-show="selected==1">
                                    <el-date-picker
                                        style="width:146px !important;min-width: 146px !important;"
                                        size="mini"
                                        v-model="weekValue"
                                        type="week"
                                        format="Week WW"
                                        value-format="yyyy-MM-dd"
                                        placeholder="Pick a week"
                                        @change="updateGraphWeek($event)">
                                    </el-date-picker>
                                </div>
                                <div v-show="selected==2">
                                    <el-date-picker
                                        style="min-width: 146px; width:146px !important;min-width: 146px !important;"
                                        size="mini"
                                        v-model="monthValue"
                                        type="month"
                                        placeholder="Pick a month"
                                        value-format="yyyy-MM-dd"
                                        @change="updateGraphMonth($event)">
                                    </el-date-picker>
                                </div>
                                <div v-show="selected==3">
                                    <el-date-picker
                                        style="width:146px !important;min-width: 146px !important;"
                                        size="mini"
                                        v-model="yearValue"
                                        type="year"
                                        placeholder="Pick a year"
                                        value-format="yyyy-MM-dd"
                                        @change="updateGraphYear($event)">
                                    </el-date-picker>
                                </div>
                                <div v-show="selected==4">
                                    <el-date-picker
                                        style="width:146px !important;min-width: 146px !important;"
                                        size="mini"
                                        v-model="customValue"
                                        type="daterange"
                                        start-placeholder="Start date"
                                        end-placeholder="End date"
                                        value-format="yyyy-MM-dd"
                                        @change="updateCustomData($event)">
                                    </el-date-picker>
                                </div>
                            </div>
                            <div style="box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05); border-radius: 8px; overflow: hidden; border: 1px #D0D5DD solid; justify-content: flex-start; align-items: flex-start; display: flex">
                                <div class="btn-group">
                                    <div class="w_button_selected" @click="changeResource" id="parcels">Parcels</div>
                                    <div class="w_button_unselected" @click="changeResource" id="tiles">Tiles</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="align-self: stretch; flex: 1 1 0; flex-direction: column;">
                        <apexchart type="bar" :options="chartOptions" :series="series" height="173px" width="696px"></apexchart>
                        <span style="font-style: italic">* Updated nightly - data may not reflect current day usage.</span>
                    </div>

                </div>

            </div>
            <div v-if="this.contract_date" style="height: 100%; flex-direction: row; justify-content: flex-start; align-items: flex-start; gap: 32px; display: inline-flex">
                <div style=" width: 264px; flex: 1 1 0; background: white; box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06); border-radius: 12px; overflow: hidden; border: 1px #EAECF0 solid; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                    <div style="align-self: stretch; flex: 1 1 0; padding: 24px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                        <div style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                            <div style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                                <div>
                                    <span style="color: #344054; font-size: 36px; font-family: Roboto; font-weight: 500; line-height: 32px; word-wrap: break-word" id="days_remaining"></span>
                                    <span style="color: #344054; font-size: 18px; font-family: Roboto; font-weight: 500; line-height: 28px; word-wrap: break-word"> <br/>days until credits expire</span>
                                </div>
                            </div>
                        </div>
                        <div style="align-self: stretch; height: 20px; flex-direction: row; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                            <div v-if="this.days_remaining > 0" style="align-self: stretch; color: #475467; font-size: 14px; font-weight: 400; line-height: 20px; word-wrap: break-word">Expiring</div>
                            <div v-else style="align-self: stretch; color: #475467; font-size: 14px; font-weight: 400; line-height: 20px; word-wrap: break-word">Expired</div>
                            <div style="align-self: stretch; color: #475467; font-size: 14px;  font-weight: 400; line-height: 20px; word-wrap: break-word" id="expiration_date"></div>
                        </div>
                    </div>
                    <div style="align-self: stretch; height: 74px; padding-bottom: 16px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
                        <div style="align-self: stretch; height: 1px; background: #EAECF0"></div>
                        <div style="align-self: stretch; padding-left: 24px; padding-right: 24px; justify-content: center; align-items: center; gap: 16px; display: inline-flex">
                            <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 12px; display: flex">
                                <div style="flex: 1 1 0; height: 41px; justify-content: center; align-items: center; gap: 8px; display: flex">
                                    <a :href="'/account/api/store'" class="button" style-size="inline">Buy Transactions</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="height: 162px; width: 264px; background: white; box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06); border-radius: 12px; overflow: hidden; border: 1px #EAECF0 solid; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                    <div style="align-self: stretch; height: 89px; background: white; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 20px; display: flex">
                        <div style="align-self: stretch; padding-top: 20px; padding-left: 24px; padding-right: 24px; justify-content: flex-start; align-items: flex-start; gap: 16px; display: inline-flex">
                            <div style="flex: 1 1 0; align-self: stretch; flex-direction: column; justify-content: center; align-items: flex-start; gap: 4px; display: inline-flex">
                                <div style="align-self: stretch; color: #101828; font-size: 16px; font-weight: 500; line-height: 24px; word-wrap: break-word">Terms and Conditions</div>
                                <div style="align-self: stretch; color: #475467; font-size: 14px; font-weight: 400; line-height: 20px; word-wrap: break-word">Signed {{ this.contract_date }} {{ this.contract_time }}</div>
                            </div>
                        </div>
                        <div style="align-self: stretch; height: 1px; background: #EAECF0"></div>
                    </div>
                    <div style="align-self: stretch; height: 73px; padding-bottom: 16px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
                        <a @click="exportClicked" class="button mt-4" style-size="inline">View Terms and Conditions</a>
                    </div>
                </div>
            </div>
            <div v-else style="width: 100%; height: 268px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 32px; display: inline-flex">
                <div style=" width: 264px; flex: 1 1 0; background: white; box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06); border-radius: 12px; overflow: hidden; border: 1px #EAECF0 solid; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: flex">
                    <div style="align-self: stretch; flex: 1 1 0; padding: 24px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px; display: flex">
                        <div style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                            <div style="align-self: stretch; height: 87px; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                                <div>
                                    <span style="color: #344054; font-size: 36px; font-family: Roboto; font-weight: 500; line-height: 32px; word-wrap: break-word" id="days_remaining"></span>
                                    <span style="color: #344054; font-size: 18px; font-family: Roboto; font-weight: 500; line-height: 28px; word-wrap: break-word"> <br/>days until credits expire</span>
                                </div>
                            </div>
                        </div>
                        <div style="align-self: stretch; height: 20px; flex-direction: row; justify-content: flex-start; align-items: flex-start; gap: 4px; display: flex">
                            <div v-if="this.days_remaining > 0" style="align-self: stretch; color: #475467; font-size: 14px; font-weight: 400; line-height: 20px; word-wrap: break-word">Expiring</div>
                            <div v-else style="align-self: stretch; color: #475467; font-size: 14px; font-weight: 400; line-height: 20px; word-wrap: break-word">Expired</div>
                            <div style="align-self: stretch; color: #475467; font-size: 14px;  font-weight: 400; line-height: 20px; word-wrap: break-word" id="expiration_date"></div>
                        </div>
                    </div>
                    <div style="align-self: stretch; height: 74px; padding-bottom: 16px; flex-direction: column; justify-content: flex-start; align-items: center; gap: 16px; display: flex">
                        <div style="align-self: stretch; height: 1px; background: #EAECF0"></div>
                        <div style="align-self: stretch; padding-left: 24px; padding-right: 24px; justify-content: center; align-items: center; gap: 16px; display: inline-flex">
                            <div style="align-self: stretch; justify-content: flex-start; align-items: flex-start; gap: 12px; display: flex">
                                <div style="flex: 1 1 0; height: 41px; justify-content: center; align-items: center; gap: 8px; display: flex">
                                    <a :href="'/account/api/store'" class="button" style-size="inline">Buy Transactions</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ApiUsageChart',
    props: [
        'contract_date',
        'contract_time',
        'client_id',
        'api_url',
        'days_remaining'
    ],
    data: function() {
        return {
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                },
                dataLabels: {
                    enabled: false
                },
                height: '696px',
                width: '173px',

                colors: ['#4A7EE8'],
                borderRadius: 30
            },
            series: [{
                name: 'Usage:',
                data: []
            }],
            selectedType: "parcels",
            parcels_used: 0,
            parcels_bought: 0,
            percent_parcels_used: 0,
            tiles_used: 0,
            tiles_bought: 0,
            percent_tiles_used: 0,
            sizingParcels: "",
            sizingTiles: "",
            monthValue: moment().year() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01",
            dayValue: moment().year() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + moment().date(),
            weekValue: moment().startOf('week').add(1,"days").format("yyyy-MM-DD"),
            yearValue: moment().year() + "-01-01",
            customValue: [moment().year() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01", moment(moment().year() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-01").endOf('month').add(1, 'days').format("yyyy-MM-DD")],
            selected: 2,
            daysBetween: null,
            totalUsage: 0,
            dailyAvg: 0,
            options: [
                { value: '0', text: 'Day' },
                { value: '1', text: 'Week' },
                { value: '2', text: 'Month' },
                { value: '3', text: 'Year' },
                { value: '4', text: 'Custom' },
            ],
            test: false

        }
    },
    methods: {
        exportClicked: function() {
            window.vm1.showModal = true;
        },
        async updateGraphDay(event) {
            let data = await this.getDayData(event);
            this.totalUsage = Math.max(...data);
            this.dailyAvg = Math.floor((this.totalUsage/data.length))
            this.series = [{
                data: data
            }]
            this.chartOptions = {
                xaxis: {
                    categories: [event.substring(5, 10).replace("-", '/')]
                },
            };
        },
        async getDayData(event) {
            let dataArray = [];
            let response = await fetch(this.api_url + this.client_id + '/'+ this.selectedType + '/day/' + moment(event).add(1, 'days').format().substring(0, 10) + '/' + moment(event).add(2, 'days').format().substring(0, 10));
            if (!response.ok) {
                dataArray.push(0)
                return dataArray
            }
            let data = await response.json();
            dataArray.push(data.quota_data[0].quota_used)
            return dataArray
        },
        async updateGraphWeek(event) {
            let data = await this.getWeekData(event);
            if (data == 0) {
                this.totalUsage = 0
                this.dailyAvg = 0
            } else {
                this.totalUsage = data.reduce((a, b) => a + b, 0);
                this.dailyAvg = Math.floor((this.totalUsage/data.length))
            }
            this.series = [{
                data: data
            }]
            let dates = [];
            dates.push(moment(event).subtract(1, 'days').format().substring(5, 10).replace("-", '/'))
            for (let i = 0; i < 6; i++) {
                dates.push(moment(event).add(i, 'days').format().substring(5, 10).replace("-", '/'))
            }
            this.chartOptions = {
                xaxis: {
                    categories: dates
                },
            };
        },
        async getWeekData(event){
            let dataArray = [];
            let response = await fetch(this.api_url + this.client_id + '/'+ this.selectedType + '/day/' + event + '/' + moment(event).add(7, 'days').format().substring(0, 10));
            if (!response.ok) {
                dataArray.push(0)
                return dataArray
            }
            let data = await response.json();
            for (let i = 0; i < 7; i++) {
                if (data.quota_data[i]) {
                    dataArray.push(data.quota_data[i].quota_used)
                } else {
                    dataArray.push(0)
                }
            }
            return dataArray
        },
        async updateGraphMonth(event) {
            let data = await this.getMonthData(event);
            if (data == 0) {
                this.totalUsage = 0
                this.dailyAvg = 0
            } else {
                this.totalUsage = data.reduce((a, b) => a + b, 0);
                this.dailyAvg = Math.floor((this.totalUsage/data.length))
            }
            this.series = [{
                data: data
            }]
            let dates = [];
            for (let i = 0; i < moment(event).daysInMonth(); i++) {
                dates.push(moment(event).add(i, 'days').format().substring(5, 10).replace("-", '/'))
            }
            this.chartOptions = {
                xaxis: {
                    categories: dates
                },
            };
        },
        async getMonthData(event){
            let dataArray = [];
            let response = await fetch(this.api_url + this.client_id + '/' + this.selectedType + '/day/' + moment(event).add(1, 'days').format().substring(0, 10) + '/' + moment(event).endOf('month').add(2, 'days').format().substring(0, 10));
            if (!response.ok) {
                dataArray.push(0)
                return dataArray
            }
            let data = await response.json();
            for (let i = 0; i < moment(event).daysInMonth(); i++) {
                if (data.quota_data[i]) {
                    dataArray.push(data.quota_data[i].quota_used)
                } else {
                    dataArray.push(0)
                }
            }
            return dataArray
        },
        async updateGraphYear(event) {
            let data = await this.getYearData(event);
            if (data == 0) {
                this.totalUsage = 0
                this.dailyAvg = 0
            } else {
                this.totalUsage = data.reduce((a, b) => a + b, 0);
                this.dailyAvg = Math.floor((this.totalUsage/12))
            }
            this.series = [{
                data: data
            }]
            this.chartOptions = {
                xaxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                },
            };
        },
        async getYearData(event){
            let dataArray = [];
            let response = await fetch(this.api_url + this.client_id + '/' + this.selectedType + '/month/' + event + '/' + moment(event).add(1, 'year').format("yyyy-MM") + "-01");
            if (!response.ok) {
                dataArray.push(0)
                return dataArray
            }
            let data = await response.json();
            for (let i = 0; i < 12; i++) {
                if (data.quota_data[i]) {
                    dataArray.push(data.quota_data[i].quota_used)
                } else {
                    dataArray.push(0)
                }
            }
            return dataArray
        },

        async updateCustomData(event) {
            let data = await this.getCustomData(event);
            if (data == 0) {
                this.totalUsage = 0
                this.dailyAvg = 0
            } else {
                this.totalUsage = Math.max(...data);
                this.dailyAvg = Math.floor((this.totalUsage/data.length))
            }
            this.series = [{
                data: data
            }]
            let dates = [];
            for (let i = 0; i < this.daysBetween; i++) {
                dates.push(moment(event[0]).add(i, 'days').format().substring(5, 10).replace("-", '/'))
            }
            this.chartOptions = {
                xaxis: {
                    categories: dates
                },
            };
        },
        async getCustomData(event) {
            let dataArray = [];
            this.daysBetween = moment(event[1]).diff(moment(event[0]),'days') + 1;
            if (this.daysBetween > 31) {
                event[1] = moment(event[0]).add(30, 'days').format().substring(0, 10)
                this.daysBetween = 31
            }
            let response = await fetch(this.api_url + this.client_id + '/'+ this.selectedType + '/day/' + moment(event[0]).add(1, 'days').format().substring(0, 10) + '/' + moment(event[1]).add(2, 'days').format().substring(0, 10));
            if (!response.ok) {
                dataArray.push(0)
                return dataArray
            }
            let data = await response.json();
            for (let i = 0; i < this.daysBetween; i++) {
                if (data.quota_data[i]) {
                    dataArray.push(data.quota_data[i].quota_used)
                } else {
                    dataArray.push(0)
                }
            }
            return dataArray
        },

        changeResource() {
            if (this.selectedType=="tiles") {
                $(document.getElementById("parcels")).removeClass().addClass('w_button_selected');
                $(document.getElementById("tiles")).removeClass().addClass('w_button_unselected');
                this.selectedType = "parcels";
            } else {
                $(document.getElementById("tiles")).removeClass().addClass('w_button_selected');
                $(document.getElementById("parcels")).removeClass().addClass('w_button_unselected');
                this.selectedType = "tiles";
            }
            this.updateGraph()
        },
        updateGraph() {
            if (this.selected==0) {
                this.updateGraphDay(this.dayValue)
            } else if (this.selected==1) {
                this.updateGraphWeek(this.weekValue)
            } else if (this.selected==2) {
                this.updateGraphMonth(this.monthValue)
            } else if (this.selected==3) {
                this.updateGraphYear(this.yearValue)
            } else if (this.selected==4) {
                this.updateCustomData(this.customValue)
            }
        }
    },
    mounted() {
        this.updateGraphMonth(this.monthValue)
        window.axios.get(
            '/account/api/quota-details'
        ).then((response) => {
            let data = response.data;
            this.parcels_used = Math.max(0, data.parcelsUsed);
            this.parcels_bought = Math.max(0, data.parcelsBought);
            if (this.parcels_bought === 0) {
                this.percent_parcels_used = 0;
                this.sizingParcels = "width: 0;";
            }
            else {
                this.percent_parcels_used = Math.round((this.parcels_used / this.parcels_bought) * 100);
                this.sizingParcels = "width: " + (this.parcels_used / this.parcels_bought) * 612 + "px;"
            }

            this.tiles_bought = Math.max(0, data.tilesBought);
            this.tiles_used = Math.max(0, data.tilesUsed);

            if (this.tiles_bought === 0) {
                this.percent_tiles_used = 0;
                this.sizingTiles = "width: 0;";
            }
            else {
                this.percent_tiles_used = Math.round((this.tiles_used / this.tiles_bought) * 100);
                this.sizingTiles = "width: " + (this.tiles_used / this.tiles_bought) * 607 + "px;"
            }
        })

    },
}
</script>


<style>

.toc {
    width: 100px;
    height: 400px;
}
/* The container must be positioned relative: */
.custom-select {
    position: relative;
    font-family: Arial;
}

.custom-select select {
    display: none; /*hide original SELECT element: */
}

.select-selected {
    background-color: DodgerBlue;
}

/* Style the arrow inside the select element: */
.select-selected:after {
    position: absolute;
    content: "";
    top: 14px;
    right: 10px;
    width: 0;
    height: 0;
    border: 6px solid transparent;
    border-color: #fff transparent transparent transparent;
}

/* Point the arrow upwards when the select box is open (active): */
.select-selected.select-arrow-active:after {
    border-color: transparent transparent #fff transparent;
    top: 7px;
}

/* style the items (options), including the selected item: */
.select-items div,.select-selected {
    color: #ffffff;
    padding: 8px 16px;
    border: 1px solid transparent;
    border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
    cursor: pointer;
}

/* Style items (options): */
.select-items {
    position: absolute;
    background-color: DodgerBlue;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 99;
}

/* Hide the items when the select box is closed: */
.select-hide {
    display: none;
}

.select-items div:hover, .same-as-selected {
    background-color: rgba(0, 0, 0, 0.1);
}

.el-input--mini .el-input__inner {
    min-width: 150px !important;
}
</style>
<style scoped>
.example-showcase .el-dropdown + .el-dropdown {
    margin-left: 15px;
}
.example-showcase .el-dropdown-link {
    cursor: pointer;
    color: blue;
    display: flex;
    align-items: center;
}
</style>
